import { render, staticRenderFns } from "./Dashboard-Lab.vue?vue&type=template&id=1ece8dda&scoped=true&"
import script from "./Dashboard-Lab.vue?vue&type=script&lang=js&"
export * from "./Dashboard-Lab.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-Lab.vue?vue&type=style&index=0&id=1ece8dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ece8dda",
  null
  
)

export default component.exports